module.exports = __webpack_public_path__ + "static/education-ea573c7c8b09a24d586990819b047852.png";